import axios, { InternalAxiosRequestConfig } from "axios";

import { AdvancedSettingsService } from "./AdvancedSettingsService";
import { CompanyService } from "./CompanyService";
import { LocationNumbersService } from "./LocationNumbersService"
import { MoveNumbersService } from "./MoveNumbersService";
import { SmsComplianceService } from "./SmsComplianceService";
import { TwilioAccountService } from "./TwilioAccountService";
import { UserService } from "./UserService";
import config from "../config";
import firebase from 'firebase/compat/app'
import { getJWT } from "../../../util/jwt_helper";

const getHeader = () => {
  return {
    channel: 'APP',
    source: 'WEB_USER',
    version: '2021-07-28',
  }
}


export const requests = (host?:string, useNewJwt = false) => {
  const baseUrl = host || config.MARKETPLACE_REST_API_URL

  const axiosInstance = axios.create(
    {
      baseURL:baseUrl,
      headers: getHeader(),
    }
  )

  axiosInstance.interceptors.request.use(async (requestConfig: InternalAxiosRequestConfig) => {
    try {
      const authToken = await getJWT(useNewJwt)
        requestConfig.headers['token-id'] = await firebase
          .auth()
          .currentUser?.getIdToken()
          if(authToken) {
            requestConfig.headers['authorization'] = `Bearer ${await getJWT(useNewJwt)}`
          }
    } catch (e) {
      console.error(`Error in getting the current user token: ${JSON.stringify(e)}`)
    }
    return requestConfig
  })

  return axiosInstance
}

export {
  AdvancedSettingsService,
  CompanyService,
  LocationNumbersService,
  MoveNumbersService,
  TwilioAccountService,
  UserService,
  SmsComplianceService
}
